/**
 * Ce que `<MediaPicker>` fait d'une pièce déposée, collée ou choisie comme fichier : pure, testée à
 * part (l'organisme ne se charge pas sous Jest).
 *
 * Un PDF ne se prend que si l'appelant tient un PDF (`onPdfChange`) et que la zone n'est pas ouverte
 * aux vidéos : « Signaler un problème » (images et vidéos, sans PDF) effaçait sinon ses pièces déjà
 * jointes, sans un mot, au dépôt d'un PDF.
 */
export type DroppedMedia = { uri: string; name?: string; mimeType?: string; fileSize?: number }

/** Pure re-impl of the legacy `checkIsPdf` — no import needed. */
export const isPdfUri = (uri?: string): boolean =>
    !!uri && (uri.startsWith("data:application/pdf") || uri.endsWith(".pdf"))

const isPdfDropped = (file: DroppedMedia): boolean =>
    file.mimeType === "application/pdf" || !!file.name?.toLowerCase().endsWith(".pdf") || isPdfUri(file.uri)

/** Un fichier que la zone accepte au dépôt : une image, une vidéo si elle les prend, sinon un PDF. */
export const isAcceptedDrop = (file: { type?: string; name?: string }, video: boolean): boolean => {
    const type = file.type ?? ""
    const name = (file.name ?? "").toLowerCase()
    if (type.startsWith("image/")) return true
    if (video) return type.startsWith("video/")
    return type === "application/pdf" || name.endsWith(".pdf")
}

/** Ce que devient une pièce reçue : le PDF de la zone, une image (ou vidéo) de plus, ou rien. */
export function droppedMediaAction(file: DroppedMedia, options: { takesPdf: boolean }): "pdf" | "media" | "ignore" {
    if (!isPdfDropped(file)) return "media"
    return options.takesPdf ? "pdf" : "ignore"
}
